import produce from 'immer';
import { v4 as uuidv4 } from 'uuid';
import { AUTH_TYPE } from './type';

const initialState = {
  idUser: null,
  idEmail: null,
  userPriv: {},
  instanceId: uuidv4(), // Génère un UUID unique pour cette instance qui sera utilisé pour la comm avec WebSocket
};
export const authReducer = (state = initialState, action, root) => {
  switch (action.type) {
    case AUTH_TYPE.CHECKED_TOKEN:
      return produce(state, (draft) => {
        draft.idUser = action.objects?.userId;
        draft.idEmail = action.objects?.email;
      });

    case AUTH_TYPE.RECEIVED_USERPRIVS:
      return produce(state, (draft) => {
        draft.userPriv = action.objects;
      });
    default:
      return state;
  }
};
